import L from 'leaflet';

export default class Map {
    constructor() {
        Map.map();
    }

    static map() {
        Map.map_api('[data-id="wpiris-map"]');
    }

    static map_api($element) {
        if ($($element).length > 0) {
            const addresses = [
                {
                    latitude: Theme.latitude,
                    longitude: Theme.longitude,
                    title: Theme.name,
                    street: Theme.street,
                    postalcode: Theme.postalcode,
                    city: Theme.city
                }
            ];

            let map = L.map('map', {
                center: [
                    parseFloat(Theme.latitude),
                    parseFloat(Theme.longitude)
                ],
                zoom: 11,
                scrollWheelZoom: false
            });

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);

            let marker_bounds = [];

            $.each(addresses, function (index, data) {

                let marker_icon = L.icon({
                    iconUrl: Theme.themeURL + '/assets/dist/images/markers/marker.png',
                    iconSize: [
                        33,
                        33
                    ]
                });

                let marker = L.featureGroup()
                    .addLayer(L.marker([
                        parseFloat(data.latitude),
                        parseFloat(data.longitude)
                    ], {icon: marker_icon}))
                    .bindPopup(Map.render_infobox(data), {
                        className: 'light',
                        autoPanPadding: L.point(30, 30),
                    })
                    .addTo(map)
                    .openPopup();

                marker_bounds.push([
                    parseFloat(data.latitude),
                    parseFloat(data.longitude)
                ]);

            });
        }
    }

    static render_infobox(data) {

        let html = '<div class="infoboxContent">' +
            '<p class="infoboxContentTitle">' + data.title + '</p>';

        if (data.street || data.postalcode || data.city) {

            html += '<p class="infoboxContentExcerpt">' +
                data.street + '<br>' +
                data.postalcode + ' ' + data.city + '<br>' +
                '</p>';
        }

        html += '<p>' +
            '<a class="infoboxContentItinerary" href="https://www.google.com/maps/dir/Ma+position/' + parseFloat(data.latitude) + ',' + parseFloat(data.longitude) + '" target="_blank"><i class="fas fa-location-arrow"></i>' + Theme.translate.calculate_my_itinerary + '</a>' +
            '</p>' +
            '</div>';

        return html;
    };
}
